import type { ReactNode } from 'react';

import styles from './HeaderItems.module.css';

/** Design px -> rem, against the app's 12px root. */
const rem = (value: number): string => `${value / 12}rem`;

/**
 * Space between the items on the right of the header (account name, avatar,
 * Ask Moo launcher). `HeaderItems` and the box that holds the launcher after it
 * both read it, so the avatar has the same space on each side.
 */
export const HEADER_ITEM_GAP = rem(16);

/**
 * Space between the Ask Moo launcher and the header's right edge. Header
 * spacing is in rem so it scales with the root font at wide viewports, the
 * same as `HEADER_ITEM_GAP` beside it.
 */
export const HEADER_END_INSET = rem(8);

interface HeaderItemsProps {
  readonly children: ReactNode;
}

/** The row a persona header lays its items out in, right-aligned. */
export const HeaderItems = ({ children }: HeaderItemsProps) => (
  <div className={styles.items} style={{ gap: HEADER_ITEM_GAP }}>
    {children}
  </div>
);
